'use client';
import type { CSSProperties, ReactElement } from 'react';
import { IconArchive, IconSearch } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { SessionsDisplayMode } from '@/types/frontend-types';
import { Cbutton } from '../Cbutton';
const TITLE_RIGHT_STYLE: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};
interface SessionsModalTitleActionsProps {
    displayMode: SessionsDisplayMode;
    isSearchInitiated: boolean;
    onToggleDisplayMode: () => void;
    onToggleSearch: () => void;
}
export function SessionsModalTitleActions({ displayMode, isSearchInitiated, onToggleDisplayMode, onToggleSearch, }: SessionsModalTitleActionsProps): ReactElement {
    return (
      <div style={TITLE_RIGHT_STYLE}>
        <Cbutton icon={IconArchive} iconSize={18} preset={displayMode === SessionsDisplayMode.Archived ? ButtonPreset.Primary : ButtonPreset.Ghost} onClick={onToggleDisplayMode}/>
        <Cbutton icon={IconSearch} iconSize={18} preset={isSearchInitiated ? ButtonPreset.Primary : ButtonPreset.Secondary} onClick={onToggleSearch}/>
      </div>
    );
}
